/**
 * <vm-zone-plate> (L4, v5.3 plate mode): hotspots on the slot-2 plate.
 * One pressed hotspot at a time; roving tabindex (one tab stop); arrow keys,
 * Home and End move between zones; the mirrored list row ([data-zx-list]) gets
 * .is-on and a polite live line ([data-zx-live]) says the zone. No animation.
 */
class VmZonePlate extends HTMLElement {
  connectedCallback() {
    this.spots = [...this.querySelectorAll('.vm-zxp__spot')];
    if (!this.spots.length) return;
    const uid = this.dataset.zxUid;
    this.list = document.querySelector(`[data-zx-list="${uid}"]`);
    this.live = document.querySelector(`[data-zx-live="${uid}"]`);
    const on = this.spots.find((s) => s.getAttribute('aria-pressed') === 'true') || this.spots[0];
    this.pick(on, false);
    this.addEventListener('click', (e) => {
      const s = e.target.closest('.vm-zxp__spot');
      if (s) this.pick(s, true);
    });
    this.addEventListener('keydown', (e) => {
      const i = this.spots.indexOf(e.target.closest('.vm-zxp__spot'));
      if (i < 0) return;
      const n = this.spots.length;
      let to;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (i + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (i - 1 + n) % n;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = n - 1;
      else return;
      e.preventDefault();
      this.pick(this.spots[to], true);
      this.spots[to].focus();
    });
  }

  pick(spot, say) {
    const zone = spot.dataset.zone;
    for (const s of this.spots) {
      const me = s === spot;
      s.setAttribute('aria-pressed', String(me));
      s.tabIndex = me ? 0 : -1;
    }
    if (this.list) for (const r of this.list.querySelectorAll('[data-zone]')) r.classList.toggle('is-on', r.dataset.zone === zone);
    if (say && this.live) this.live.textContent = spot.dataset.say || spot.getAttribute('aria-label');
  }
}

if (!customElements.get('vm-zone-plate')) customElements.define('vm-zone-plate', VmZonePlate);
